import styled from 'styled-components/macro';

const Title = styled.h1`
  font-size: 36px;
  font-weight: 600;
`;

export default Title;
